import React, { useState } from 'react';
import clsx from 'clsx';

import { Paragraph } from '@arctheme-components/elements/Paragraph/Paragraph';

import shopifyHelpers from 'frontend/js/shopify';

export const ProductDescription = ({ settings }) => {
  const { settings: blockSettings, tabs } = settings;
  const { heading_style, text_style } = blockSettings;

  const [activeTab, setActiveTab] = useState(0);

  const tabsToShow = tabs.filter((tab) => tab.title && tab.content);
  const showTitle = tabsToShow.length > 1;

  if (!tabs.length) return null;

  return (
    <div className='pdp-tabs__description'>
      {showTitle && (
        <ul className='tab-list grid grid-cols-2 text-center pb-4'>
          {tabsToShow.map((tab, index) => (
            <li
              key={tab.title}
              className={clsx({
                'tab-title': true,
                active: index === activeTab
              })}
              onClick={() => setActiveTab(index)}
            >
              <span className={`tab-title__text ${heading_style}`}>{tab.title}</span>
            </li>
          ))}
        </ul>
      )}

      <div className='pdp-tabs__content rte max-w-[unset]'>
        {tabsToShow.map((tab, index) => (
          <div
            key={tab.title}
            className={`${index === activeTab ? 'block' : 'hidden'}`}
          >
            <Paragraph
              text={shopifyHelpers.decodeLiquidEscape(tab.content)}
              type={text_style}
              maxChars={100000}
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default ProductDescription;
